import { DocumentData, FirestoreDataConverter, QueryDocumentSnapshot } from 'firebase/firestore/lite';

import LegalDocumentData from '../types/legalDocumentData';

const legalDocumentConverter: FirestoreDataConverter<LegalDocumentData> = {
  toFirestore(legalDocument: LegalDocumentData): DocumentData {
    return legalDocument;
  },

  fromFirestore(docSnap: QueryDocumentSnapshot): LegalDocumentData {
    return {
      ...docSnap.data(),
      text: docSnap.data().text.replaceAll('\\n', '\n'),
      id: docSnap.id,
    } as LegalDocumentData;
  },
};

export default legalDocumentConverter;
